module.exports = __webpack_public_path__ + "static/media/letterheadHeader_1706788148.04cac952.png";